import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseApiService} from '../base-api.service';
import {Service} from '../../model/service';

@Injectable({
  providedIn: 'root'
})
export class ServiceService extends BaseApiService<Service> {
  protected endpoint = '/service';

  constructor(protected override http: HttpClient) {
    super(http);
  }
}
